import React from "react";
import { Box, Link } from "@mui/material";

const FooterLinks = ({short, alignCenter}: any) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="right"
      justifyContent={alignCenter ? "center" : "flex-end"}
      width="100%"
      p={1}
      gap={1}
    >
      {/* About Link */}
      <Box mb={2}>
        <Link href="/about" underline="hover" color="text.primary">
          {!!short ? 'About' : 'About'}
        </Link>
      </Box>
      <Box mb={2}>|</Box>
      {/* About Link */}
      <Box mb={2}>
        <Link href="/privacy" underline="hover" color="text.primary">
          {!!short ? 'Privacy' : 'Privacy Policy'}
        </Link>
      </Box>
      <Box mb={2}>|</Box>
      {/* About Link */}
      <Box mb={2}>
        <Link href="/terms" underline="hover" color="text.primary">
          {!!short ? 'Terms' : 'Terms & Conditions'}
        </Link>
      </Box>
    </Box>
  );
};

export default FooterLinks;
